// extracted by mini-css-extract-plugin
export default {"input":"AddCategoryModal_input__fl+dF","required":"AddCategoryModal_required__YsEfc"};